import { InputBoxed } from '@creditas-ui/react';
import React from 'react';
import type { ChangeEvent, FormEvent } from 'react';
import { useEjnFilters } from '../../../contexts/ejn';
import { dateString } from '../../../utils/helpers';

const EjnFilterBySentAtComponent: React.FC = () => {
  const { changeFilter, sentAt } = useEjnFilters();

  const handleDate = (
    event: ChangeEvent<HTMLInputElement> | FormEvent<HTMLInputElement>,
  ) => {
    const newDate = new Date(
      `${(event.target as HTMLTextAreaElement).value}T12:00:00Z`,
    );
    changeFilter({ sentAt: dateString(newDate) });
  };

  return (
    <InputBoxed
      id="sentAt"
      label={'sentAt'}
      name="sentAt"
      type="date"
      value={sentAt}
      onChange={handleDate}
      crossOrigin={undefined}
    />
  );
};

const EjnFilterBySentAt = React.memo(EjnFilterBySentAtComponent);

export default EjnFilterBySentAt;
